// api/upload.js
import request from '@/utils/request'
// 获取用户信息
export const getUserInfoAPI = (id) => {
  return request({
    url: `/users/info`,
    method: 'get',
    params:{
      user_id:id
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'multipart/form-data'
    }
  })
}
// 修改用户账号
export const editAccountAPI = (id,new_account) => {
  return request({
    url: `/users/account`,
    method: 'put',
    data:{
      user_id:id,
      new_account
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'application/json'
    }
  })
}
// 修改密码
export const editPwdAPI = (id,new_password) => {
  return request({
    url: `/users/password`,
    method: 'put',
    data:{
      user_id:id,
      new_password
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'application/json'
    }
  })
}
// 修改手机号
export const editPhoneAPI = (id,new_phone) => {
  return request({
    url: `/users/phone`,
    method: 'put',
    data:{
      user_id:id,
      new_phone
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'application/json'
    }
  })
}
// 充值
export const rechargeAPI = (id,amount) => {
  return request({
    url: `/users/recharge`,
    method: 'post',
    data:{
      user_id:id,
      amount
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'application/json'
    }
  })
}
// 用户注销
export const logOffAPI = (id) => {
  return request({
    url: `/users/delete`,
    method: 'put',
    data:{
      user_id:id
    },
    headers: {
      // 让浏览器自动设置 multipart 边界
      'Content-Type': 'application/json'
    }
  })
}
// 检查用户当天使用次数
export const checkDailyAPI = (id) => {
  return request({
    url: `/users/check_daily`,
    method: 'get',
    params:{
      user_id:id
    }
  })
}

// 检测用户登录状态
export const checkTokenAPI = (token) => {
  return request({
    url: `/users/check_token`,
    method: 'get',
    params:{
      token
    }
  })
}